import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { GtagService } from './gtag.service';

@Directive({
    selector: '[appGtagEvent]',
    standalone: true,
})
export class GtagEventDirective implements AfterViewInit {
  @Input() trackOn: string;
  @Input() action: string;
  @Input() category: string;
  @Input() params: any;

  constructor(
      private gtag: GtagService,
      private renderer: Renderer2,
      private el: ElementRef,
  ) {
  }

  ngAfterViewInit() {
    try {
      this.renderer.listen(this.el.nativeElement, this.trackOn, () => {
        this.gtag.event(this.action || this.trackOn, {
          event_category: this.category,
          ...this.params,
        });
      });
    } catch (err) {
      console.error(err);
    }
  }
}
